import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const searchPapers = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/search-papers`, data);
    return response.data;
  } catch (error) {
    console.error('Error searching papers:', error);
    throw error;
  }
};

export const getPaperRecommendations = async (data) => {
  try {
    // Handle both string and object parameters for backward compatibility
    const payload = typeof data === 'string'
      ? { paperUrl: data }
      : data;

    const response = await axios.post(`${API_URL}/paper-recommendations`, payload);
    return response.data;
  } catch (error) {
    console.error('Error getting paper recommendations:', error);
    throw error;
  }
};

export const generateReview = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/generate-review`, data);
    return response.data;
  } catch (error) {
    console.error('Error generating review:', error);
    throw error;
  }
};

export const regenerateWithPlan = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/regenerate-with-plan`, data);
    return response.data;
  } catch (error) {
    console.error('Error regenerating with plan:', error);
    throw error;
  }
};